import type { FC } from "react";

import type { Action, ActionAction, MainBanner, Pages } from "~/core";
import { Background } from "~/shared/ui-kit";

import { Column } from "./components/Column";
import { Row } from "./components/Row";

export type ImageParams = {
  format?:
    | "jpg"
    | "jpeg"
    | "png"
    | "gif"
    | "webp"
    | "avif"
    | "svg"
    | "bmp"
    | "ico"
    | "tiff";
  height?: number;
  width?: number;
};
export type MainBannerV2Props = {
  data: MainBanner;
  getUrl: (page: Pages) => string;
  onCallAction: (action: ActionAction) => void;
  getImageUrl: (imageId: string, params?: ImageParams) => string;
  isControlInactive: (control: Action) => boolean;
};
export type BannerVariant = "row" | "column";

const getBannerVariant = (data: MainBanner): BannerVariant => {
  return data.variant === "row" ? "row" : "column";
};

export const MainBannerV2: FC<MainBannerV2Props> = (props) => {
  const {
    data,

    getImageUrl,
  } = props;
  const bannerVariant = getBannerVariant(data);

  return (
    <Background
      bgValue={
        data.backgroundImage
          ? getImageUrl(data.backgroundImage.id)
          : (data.backgroundColor ?? "")
      }
      mdBgValue={
        data.backgroundImage
          ? getImageUrl(data.backgroundImage.id)
          : (data.backgroundColor ?? "")
      }
      dBgValue={
        data.backgroundImage
          ? getImageUrl(data.backgroundImage.id)
          : (data.backgroundColor ?? "")
      }
    >
      {bannerVariant === "column" ? <Column {...props} /> : <Row {...props} />}
    </Background>
  );
};
